import { render, staticRenderFns } from "./RealNameAuth.vue?vue&type=template&id=6e42942e&scoped=true"
import script from "./RealNameAuth.vue?vue&type=script&lang=js"
export * from "./RealNameAuth.vue?vue&type=script&lang=js"
import style0 from "./RealNameAuth.vue?vue&type=style&index=0&id=6e42942e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42942e",
  null
  
)

export default component.exports